import {
  checkStatus,
  UnknownResponseError,
} from './http-errors';
import checkResponseBodyCode from './response-errors';

const versionGroup = '/api/v1';

// ALL fetches to backend services should use this so that the JWT is passed.
// Uses the 'Bearer' header to transmit the token, as described here: https://tools.ietf.org/html/rfc6750
//
// url:         The route to the server resource.
// accept: A MIME type specifying the type of content that the response is expected to be.
// Options:     Any extra options that should be passed to fetch.
// skipCheck:   Skip the response body code check.
function secureFetch(url, accessToken, options, accept = 'application/json', skipCheck = false) {
  if (!accessToken) {
    throw new Error('Session expired');
  }

  return fetch(`${versionGroup}/${url}`, {
    headers: {
      Accept: accept,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    ...options,
  })
    .then((response) => {
      checkStatus(response);
      const contentType = response.headers.get('Content-Type');
      if (!contentType) {
        return null;
      }

      if (contentType.startsWith('application/json')) {
        return response.json().then((json) => (skipCheck ? json : checkResponseBodyCode(json)));
      }

      // If the response has an attachment header, it is decoded as a blob and downloaded.
      const contentDisposition = response.headers.get('Content-Disposition');
      if (!contentDisposition) throw new UnknownResponseError();

      // Example match: 'attachment; filename=Redeemed Vouchers 10/01/2019.csv';
      const match = contentDisposition.match(/^attachment; filename=(.+\.\w+)$/);
      if (!match) throw new UnknownResponseError();

      const fileName = match[1];
      if (!fileName) throw new UnknownResponseError();

      return response.blob().then((attachment) => {
        // Creates a link and clicks it to download the blob.
        // The link is then removed.

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([attachment]));
        // '/' and ':' are illegal filename characters. Replace them with similar unicode chars.
        link.setAttribute('download', fileName
          .replace(/\//g, '\u2215')
          .replace(/:/g, '\ua789'));

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    });
}

export default secureFetch;
